import { Props } from 'shared/@types';
import { MarkdownPage } from 'shared/components/markdown-page';
import { useTranslation } from 'react-i18next';

const PurchaseTermsScreen = ({}: Props) => {
  const { t } = useTranslation('documents');

  return <MarkdownPage markdown={t('purchase_terms')} />;
};

export { PurchaseTermsScreen };
